(function(scope){
  function shipping(cart, rule){
    const total=Math.max(0,Number(cart.total_price)||0), threshold=Math.round(Number(rule.threshold)*100);
    const country=String(rule.country||'').toUpperCase(), currency=String(cart.currency||rule.currency||'').toUpperCase();
    const countries=String(rule.countries||'').toUpperCase().split(',').map(s=>s.trim());
    const eligible=rule.enabled===true&&cart.requires_shipping!==false&&cart.item_count>0&&currency===rule.ruleCurrency&&countries.includes(country)&&threshold>0&&total<=Number(rule.maximum)*100;
    return {eligible,threshold,remaining:eligible?Math.max(0,threshold-total):null,free:eligible&&total>=threshold,progress:eligible?Math.min(100,total/threshold*100):0};
  }
  const api={shipping}; if(typeof module!=='undefined'&&module.exports)module.exports=api;scope.IKAOCartRules=api;
})(typeof window!=='undefined'?window:globalThis);
